import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  Button,
  MenuItem,
  Alert,
  FormControlLabel,
  FormControl,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { validateInvoiceIntegratorAccount } from "../../../../utils/validation";
import useAlert from "../../../../hooks/useAlert";
import {
  addInvoiceIntegratorsAccount,
  getInvoiceIntegrators,
  getInvoiceIntegratorsAccounts,
  updateInvoiceIntegratorsAccount,
} from "../../../../redux/actions/invoiceIntegratorActions";
import { IoMdSave } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`InvoiceIntegrator-tabpanel-${index}`}
      aria-labelledby={`InvoiceIntegrator-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
const INVOICEINTEGRATOR_FIELDS = {
  mysoft: [
    {
      id: "Username",
      label: "Kullanıcı Adı",
      valueId: "Username",
      type: "key",
    },
    {
      id: "Password",
      label: "Şifre",
      valueId: "Password",
      type: "key",
      secure: true,
    },
    {
      id: "TenantIdentifierNumber",
      label: "Firma VKN/TCKN",
      valueId: "TenantIdentifierNumber",
      type: "key",
    },
    {
      id: "PkAlias",
      label: "PK Alias",
      valueId: "PkAlias",
      type: "key",
    },
  ],
  turkcell: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    {
      id: "CompanyCountry",
      label: "Ülke",
      valueId: "CompanyCountry",
      type: "key",
    },
    { id: "CompanyCity", label: "Şehir", valueId: "CompanyCity", type: "key" },
    {
      id: "CompanyDistrict",
      label: "İlçe",
      valueId: "CompanyDistrict",
      type: "key",
    },
    {
      id: "CompanyPostalZone",
      label: "Posta Kodu",
      valueId: "CompanyPostalZone",
      type: "key",
    },
    {
      id: "CompanyStreet",
      label: "Sokak",
      valueId: "CompanyStreet",
      type: "key",
    },
    {
      id: "CompanyBuildingName",
      label: "Bina Adı",
      valueId: "CompanyBuildingName",
      type: "key",
    },
    {
      id: "CompanyBuildingNo",
      label: "Bina Numarası",
      valueId: "CompanyBuildingNo",
      type: "key",
    },
    {
      id: "CompanyRoom",
      label: "Kapı Numarası",
      valueId: "CompanyRoom",
      type: "key",
    },
    {
      id: "CompanySenderTag",
      label: "Gönderici Mail",
      valueId: "CompanySenderTag",
      type: "key",
    },
    {
      id: "CompanyIdentity",
      label: "Vergi Numarası",
      valueId: "CompanyIdentity",
      type: "key",
    },
    {
      id: "CompanyName",
      label: "Şirket Ünvanı",
      valueId: "CompanyName",
      type: "key",
    },
  ],
};

const DEFAULT_FIELDS = [
  { id: "ApiKey", label: "Api Key", valueId: "ApiKey" },
  { id: "ApiSecret", label: "Api Secret", valueId: "ApiSecret" },
];

const DeliveryType = [
  { id: "buyerPays", name: "Alıcı Öder" },
  { id: "sellerPays", name: "Satıcı Öder" },
];
const ProductTypeIkas = [
  { id: "PHYSICAL", name: "Fiziksel" },
  { id: "DIGITAL", name: "Dijital" },
];
const ProductType = [
  { id: "physical", name: "Fiziksel" },
  { id: "digital", name: "Dijital" },
];

const Currency = [
  { id: "EUR_BID", name: "EUR_BID" },
  { id: "EUR", name: "Euro" },
  { id: "GBP_BID", name: "GBP_BID" },
  { id: "GBP", name: "British Pound" },
  { id: "USD_BID", name: "USD_BID" },
  { id: "USD", name: "US Dollar" },
  { id: "TRY", name: "TRY" },
];
const CurrencyTicimax = [
  { id: "1", name: "TL" },
  { id: "4", name: "CHF" },
  { id: "3", name: "EURO" },
  { id: "2", name: "USD" },
];
const CurrencyIkas = [
  { id: "TRY", name: "Türk Lirası" }, // Türk Lirası
  { id: "USD", name: "Amerikan Doları" }, // Amerikan Doları
  { id: "EUR", name: "Euro" }, // Euro
  { id: "GBP", name: "İngiliz Sterlini" }, // İngiliz Sterlini
  { id: "JPY", name: "Japon Yeni" }, // Japon Yeni
  { id: "CHF", name: "İsviçre Frangı" }, // İsviçre Frangı
  { id: "CAD", name: "Kanada Doları" }, // Kanada Doları
  { id: "AUD", name: "Avustralya Doları" }, // Avustralya Doları
  { id: "RUB", name: "Rus Rublesi" }, // Rus Rublesi
  { id: "CNY", name: "Çin Yuanı" }, // Çin Yuanı
  { id: "SAR", name: "Suudi Arabistan Riyali" }, // Suudi Arabistan Riyali
  { id: "AED", name: "Birleşik Arap Emirlikleri Dirhemi" }, // BAE Dirhemi
  { id: "INR", name: "Hint Rupisi" }, // Hint Rupisi
  { id: "KRW", name: "Güney Kore Wonu" }, // Güney Kore Wonu
  { id: "BRL", name: "Brezilya Reali" }, // Brezilya Reali
  { id: "ZAR", name: "Güney Afrika Randı" }, // Güney Afrika Randı
  { id: "SEK", name: "İsveç Kronu" }, // İsveç Kronu
  { id: "NZD", name: "Yeni Zelanda Doları" }, // Yeni Zelanda Doları
  { id: "MXN", name: "Meksika Pesosu" }, // Meksika Pesosu
  { id: "SGD", name: "Singapur Doları" }, // Singapur Doları
  { id: "HKD", name: "Hong Kong Doları" }, // Hong Kong Doları
];
const InvoiceIntegrator = ({
  market,
  appUserId,
  formErrors,
  setFormErrors,
  showSuccessInvoiceIntegratorAccountAdd,
  showErrorAlertInvoiceIntegratorAccountAdd,
  showSuccessInvoiceIntegratorAccountUpdate,
  showErrorAlertInvoiceIntegratorAccountUpdate,
  getInvoiceIntegrator,
  getInvoiceIntegratorAccounts,
  data,
  token,
  setLoading,
}) => {
  const hasExistingData =
    data &&
    Array.isArray(data) &&
    data.some((item) => item.integratorId === market.id);
  const [formData, setFormData] = useState(() => {
    const initialData = {};
    if (data && Array.isArray(data)) {
      const marketSpecificData = data.filter(
        (item) => item.integratorId === market.id
      );
      marketSpecificData.forEach((item) => {
        const fields =
          INVOICEINTEGRATOR_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
        const field = fields.find((f) => f.valueId === item.valueId);
        if (field) {
          initialData[field.id] = item.value;
        }
      });
    }
    return initialData;
  });

  const handleInputChange = (fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }));
  };

  const dispatch = useDispatch();

  const addInvoiceIntegratorAccount = async (event) => {
    event.preventDefault();
    const fields =
      INVOICEINTEGRATOR_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const InvoiceIntegratorData = fields.map((field) => ({
      InvoiceIntegratorId: market.id,
      valueId: field.valueId,
      value: formData[field.id] || "",
      appUserId: appUserId,
      type: field.type,
    }));

    const errors = validateInvoiceIntegratorAccount(InvoiceIntegratorData);
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        setLoading(true);
        console.log(InvoiceIntegratorData);
        const response = await dispatch(
          addInvoiceIntegratorsAccount({ InvoiceIntegratorData }, token)
        );
        getInvoiceIntegrator();
        getInvoiceIntegratorAccounts();
        setLoading(false);
        showSuccessInvoiceIntegratorAccountAdd();
      } catch (err) {
        setLoading(false);
        showErrorAlertInvoiceIntegratorAccountAdd();
        console.log("Market ayarları eklenemedi", err);
      }
    }
  };

  const updateInvoiceIntegratorAccount = async (event) => {
    event.preventDefault();

    const fields =
      INVOICEINTEGRATOR_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const InvoiceIntegratorData = fields.map((field) => {
      const matchingData = data.find(
        (d) => d.integratorId === market.id && d.valueId === field.valueId
      );

      return {
        id: matchingData?.id,
        InvoiceIntegratorId: market.id,
        valueId: field.valueId,
        value: formData[field.id] || "",
        appUserId: appUserId,
        type: field.type,
      };
    });

    const errors = validateInvoiceIntegratorAccount(InvoiceIntegratorData);
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        setLoading(true);
        const response = await dispatch(
          updateInvoiceIntegratorsAccount({ InvoiceIntegratorData }, token)
        );
        showSuccessInvoiceIntegratorAccountUpdate();
        getInvoiceIntegrator();
        getInvoiceIntegratorAccounts();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        showErrorAlertInvoiceIntegratorAccountUpdate();
        console.log("Market ayarları güncellenemedi", err);
      }
    }
  };

  const renderFields = () => {
    const fields =
      INVOICEINTEGRATOR_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const keyFields = fields.filter((field) => field.type === "key");
    const settingsFields = fields.filter((field) => field.type === "settings");

    return (
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        {keyFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Bağlantı Ayarları
              </Typography>
            </Grid>
            {keyFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                <TextField
                  size="small"
                  fullWidth
                  type={field.secure ? "password" : "text"}
                  label={field.label}
                  value={formData[field.id] || ""}
                  onChange={(e) => handleInputChange(field.id, e.target.value)}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                  }}
                  error={formErrors?.find(
                    (k) =>
                      k.type == "key" &&
                      k.integratorId == market.id &&
                      k.valueId == field?.id
                  )}
                  helperText={
                    formErrors?.find(
                      (k) =>
                        k.type == "key" &&
                        k.integratorId == market.id &&
                        k.valueId == field?.id
                    )?.value || ""
                  }
                />
              </Grid>
            ))}
          </>
        )}

        {/* Genel Ayarlar */}
        {settingsFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Genel Ayarlar
              </Typography>
            </Grid>

            {settingsFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                {field.id === "Taxable" ? (
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData[field.id] === "true"}
                          onChange={(e) =>
                            handleInputChange(
                              field.id,
                              e.target.checked ? "true" : "false"
                            )
                          }
                          color="primary"
                        />
                      }
                      label={field.label}
                    />
                  </FormControl>
                ) : field.id === "FreeShipping" ? (
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData[field.id] === "true"}
                          onChange={(e) =>
                            handleInputChange(
                              field.id,
                              e.target.checked ? "true" : "false"
                            )
                          }
                          color="primary"
                        />
                      }
                      label={field.label}
                    />
                  </FormControl>
                ) : field.id == "Currency" && market.name == "Ticimax" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.integratorId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.integratorId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {CurrencyTicimax.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id == "Currency" && market.name == "Ikas" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.integratorId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.integratorId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {CurrencyIkas.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id == "Currency" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.integratorId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.integratorId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {Currency.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    select={
                      field.impuType === "DeliveryType" ||
                      field.impuType === "ProductType"
                    }
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.integratorId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.integratorId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                    placeholder={field?.placeholder}
                  >
                    {field.impuType === "DeliveryType" &&
                      DeliveryType.map((x) => (
                        <MenuItem key={x.id} value={x.id}>
                          {x.name}
                        </MenuItem>
                      ))}

                    {field.impuType === "ProductType" && market.name == "Ikas"
                      ? ProductTypeIkas.map((x) => (
                          <MenuItem key={x.id} value={x.id}>
                            {x.name}
                          </MenuItem>
                        ))
                      : ProductType.map((x) => (
                          <MenuItem key={x.id} value={x.id}>
                            {x.name}
                          </MenuItem>
                        ))}
                  </TextField>
                )}
              </Grid>
            ))}
          </>
        )}
      </Grid>
    );
  };
  return (
    <form
      onSubmit={
        hasExistingData
          ? updateInvoiceIntegratorAccount
          : addInvoiceIntegratorAccount
      }
    >
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" } }}
          >
            {market.name} Ayarları
          </Typography>
        </Grid>
        {renderFields()}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
            mt: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Button
            type="submit"
            variant="contained"
            startIcon={<IoMdSave />}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            Kaydet
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

const InvoiceIntegratorAccount = () => {
  const {
    showSuccessInvoiceIntegratorAccountAdd,
    showErrorAlertInvoiceIntegratorAccountAdd,
  } = useAlert();
  const {
    showSuccessInvoiceIntegratorAccountUpdate,
    showErrorAlertInvoiceIntegratorAccountUpdate,
  } = useAlert();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [formErrors, setFormErrors] = useState([]);
  const [value, setValue] = useState(0);
  const [formValues, setFormValues] = useState([]);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const getInvoiceIntegrator = async (token) => {
    try {
      const response = await dispatch(getInvoiceIntegrators(token));
      if (response.success) {
        setFormValues(response?.data);
      }
    } catch (err) {
      console.log("Marketler getirilemedi", err);
    }
  };
  const getInvoiceIntegratorAccounts = async () => {
    try {
      const response = await dispatch(
        getInvoiceIntegratorsAccounts(authUserId, token)
      );

      if (response.success) {
        setData(response?.data);
      }
    } catch (err) {
      console.log("Marketler hesap bilgileri getirilemedi", err);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getInvoiceIntegrator();
      await getInvoiceIntegratorAccounts();
      setLoading(false);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: { xs: "200px", sm: "300px", md: "400px" },
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (formValues.length > 0) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="InvoiceIntegrator tabs"
            sx={{
              "& .MuiTab-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                minWidth: { xs: "80px", sm: "100px", md: "120px" },
              },
            }}
          >
            {formValues.map((market) => (
              <Tab
                key={market.id}
                label={market.name}
                id={`InvoiceIntegrator-tab-${market.id}`}
                aria-controls={`InvoiceIntegrator-tabpanel-${market.id}`}
              />
            ))}

            <Tab
              key={formValues.length}
              label={
                <span style={{ fontSize: "30px", fontWeight: "bold" }}>+</span>
              }
              id={`InvoiceIntegrator-tab-${formValues.length}`}
              aria-controls={`InvoiceIntegrator-tab-${formValues.length}`}
            />
          </Tabs>
        </Box>
        {formValues.map((market, index) => (
          <TabPanel key={market.id} value={value} index={index}>
            <InvoiceIntegrator
              market={market}
              appUserId={authUserId}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              showSuccessInvoiceIntegratorAccountAdd={
                showSuccessInvoiceIntegratorAccountAdd
              }
              showErrorAlertInvoiceIntegratorAccountAdd={
                showErrorAlertInvoiceIntegratorAccountAdd
              }
              showSuccessInvoiceIntegratorAccountUpdate={
                showSuccessInvoiceIntegratorAccountUpdate
              }
              showErrorAlertInvoiceIntegratorAccountUpdate={
                showErrorAlertInvoiceIntegratorAccountUpdate
              }
              getInvoiceIntegrator={getInvoiceIntegrator}
              getInvoiceIntegratorAccounts={getInvoiceIntegratorAccounts}
              data={data}
              token={token}
              setLoading={setLoading}
            />
          </TabPanel>
        ))}

        <TabPanel
          key={formValues.length}
          value={value}
          index={formValues.length}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 4,
            }}
          >
            <Alert severity="info" sx={{ width: "100%", marginBottom: 4 }}>
              Yeni bir E-Fatura Platformu eklemek için aşağıdaki butona
              tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
            >
              Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <TabPanel value={0} index={0}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Alert
              severity="info"
              sx={{
                width: "100%",
                marginBottom: { xs: 2, sm: 3, md: 4 },
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Henüz hiç E-Fatura Platformu eklenmemiş. Yeni bir E-Fatura
              Platformu eklemek için aşağıdaki butona tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
              sx={{
                width: { xs: "100%", sm: "auto" },
                fontSize: { xs: "0.875rem", sm: "1rem" },
                padding: { xs: "8px 16px", sm: "10px 20px" },
              }}
            >
              Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  }
};

export default InvoiceIntegratorAccount;
